import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { planSettingsPath } from "@circle-react/helpers/urlHelpers";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

const localeRoot = "trial_banner.marketing_campaign";

export const MarketingCampaignOffer = () => {
  const navigate = useNavigate();
  const { isCircleV4 } = useCircleV4();

  const handleOnClick = () => {
    void navigate({ to: planSettingsPath() });
  };

  if (isCircleV4) {
    return (
      <Banner
        variant="info"
        title={t(`${localeRoot}.title`)}
        description={t(`${localeRoot}.description`)}
        actionProps={{
          variant: "gradient",
          children: t(`${localeRoot}.cta`),
          onClick: handleOnClick,
        }}
      />
    );
  }

  return (
    <div>
      <div className="flex items-center gap-2">
        <Icon type="16-clock" size={16} />
        <Typography.BodySm
          weight="font-semibold"
          color="text-white"
          size="text-md"
        >
          {t(`${localeRoot}.title`)}
        </Typography.BodySm>

        <Button
          className="ml-1 text-md font-semibold"
          variant="secondary"
          onClick={handleOnClick}
        >
          {t(`${localeRoot}.cta`)}
        </Button>
      </div>
    </div>
  );
};
